import { Component } from '@angular/core';
import { ToolBarMenu } from '@maced/angular-components/lib/navigation-drawer/toolbar/toolbar.model';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html'
})
export class ToolbarComponent {
  toolbarMenuList: ToolBarMenu[] = [
    { id: "Toolbar", name: "Cursor", tooltip: "Cursor", icon: "icon-cursor", isDivider: true, disable: true, url: "/button", queryParams: { isClicked: true } },
    { id: "Selection", name: "Selection", tooltip: "Selection", icon: "icon-selection", url: "/card", queryParams: { isClicked: true } },
    { id: "Pen", name: "Pen", tooltip: "Pen", icon: "icon-pencil", url: "/header", queryParams: { isClicked: true } },
    { id: "Highlighter", name: "Highlighter", tooltip: "Highlighter", icon: "icon-pencil-line", url: "/modal-header", queryParams: { isClicked: true } },
    { id: "Text", name: "Text", tooltip: "Text", icon: "icon-type", url: "/button", queryParams: { isClicked: true } },
    { id: "Mask", name: "Mask", tooltip: "Mask", icon: "icon-mask", isDivider: true, url: "/card", queryParams: { isClicked: true } },
    { id: "Save Progress", name: "Save Progress", tooltip: "Save Progress", icon: "icon-save", isDivider: true, url: "/button" },
    { id: "Delete Selected", name: "Delete Selected", tooltip: "Delete Selected", icon: "icon-trash", url: "/card" }
  ];
}